// Presale promo: auto-adds a free P1 Meter to the cart whenever it contains an XDS 4.0 or
// XDS 4.1 line, and removes it again if those lines are removed. Pairs with a Shopify
// automatic "Buy X get Y" discount (configured in Admin > Discounts) that makes the added
// P1 Meter line free at checkout — this script only handles getting it into the cart, the
// discount handles the price.
//
// Single on/off switch: window.PRESALE_GIFT_ENABLED, set from snippets/presale-gift-config.liquid
// in layout/theme.liquid. Flip that one snippet to false to stop this (and the banner) entirely.
//
// A cart line is treated as "the auto-added free gift" only when it is the P1 Meter AND its
// final_line_price is 0 (i.e. actually discounted to free). This avoids deleting a P1 Meter a
// customer added and paid for on its own, outside the promo.
(() => {
  if (!window.PRESALE_GIFT_ENABLED) return;
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || typeof routes === 'undefined') return;

  // Products that trigger the free gift. Update this list if the presale products change.
  const TRIGGER_HANDLES = [
    'adaptme-plug-and-play-thuisbatterij', // XDS 4.0
    'products-xds-4-1-thuisbatterij-zonnepanelen', // XDS 4.1
  ];
  // The P1 Meter's product handle in Shopify admin.
  const GIFT_HANDLE = 'p1-meter';

  let syncing = false;
  let giftVariantIdPromise = null;

  function getGiftVariantId() {
    if (!giftVariantIdPromise) {
      giftVariantIdPromise = fetch(`/products/${GIFT_HANDLE}.js`)
        .then((response) => (response.ok ? response.json() : null))
        .then((product) => product?.variants?.[0]?.id || null)
        .catch(() => null);
    }
    return giftVariantIdPromise;
  }

  function syncCartIconBubble() {
    fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const source = html.getElementById('cart-icon-bubble');
        const target = document.getElementById('cart-icon-bubble');
        if (source && target) target.innerHTML = source.innerHTML;
      })
      .catch(() => {});
  }

  function announceCartChange(cartData) {
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'presale-gift', cartData });
    syncCartIconBubble();
  }

  function addGift() {
    getGiftVariantId().then((variantId) => {
      if (!variantId) return;
      syncing = true;
      fetch(routes.cart_add_url, {
        ...fetchConfig(),
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) return; // e.g. gift product sold out/unpublished — fail silently
          announceCartChange(response);
        })
        .catch(() => {})
        .finally(() => {
          syncing = false;
        });
    });
  }

  function removeGift(lineKey) {
    syncing = true;
    fetch(routes.cart_change_url, {
      ...fetchConfig(),
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    })
      .then((response) => response.json())
      .then((response) => announceCartChange(response))
      .catch(() => {})
      .finally(() => {
        syncing = false;
      });
  }

  function reconcile() {
    if (syncing) return;
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const hasTrigger = cart.items.some((item) => TRIGGER_HANDLES.includes(item.handle));
        const freeGiftLine = cart.items.find((item) => item.handle === GIFT_HANDLE && item.final_line_price === 0);

        if (hasTrigger && !freeGiftLine) {
          addGift();
        } else if (!hasTrigger && freeGiftLine) {
          removeGift(freeGiftLine.key);
        }
      })
      .catch(() => {});
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event?.source === 'presale-gift') return; // don't react to our own change
    reconcile();
  });

  document.addEventListener('DOMContentLoaded', reconcile);
})();
